export default {
  subtitle: "Le chiavi autenticano le richieste alla Partner API. Inviale nell'header x-api-key.",
  never_used: 'Mai utilizzata',
  revoke_confirm: 'Revocare questa chiave? Le richieste che la utilizzano smetteranno di funzionare immediatamente.',
  columns: {
    name: 'Nome',
    key: 'Chiave',
    status: 'Stato',
    last_used_at: 'Ultimo utilizzo',
    created_at: 'Creata',
  },
  statuses: {
    active: 'Attiva',
    revoked: 'Revocata',
  },
  buttons: {
    create: 'Crea chiave',
    revoke: 'Revoca',
  },
  toasts: {
    load_error: 'Impossibile caricare le chiavi API.',
    error: 'Qualcosa è andato storto. Riprova.',
    revoked: 'Chiave API revocata.',
  },
};
